(function(angular, module) {var itemDirective;

itemDirective = function(moment) {
  "ngInject";
  return {
    restrict: 'A',
    templateUrl: 'programs/initiatives/amcGrantReportItem',
    require: '^amcGrantReportSection',
    scope: {
      config: '=amcGrantReportItem',
      grantReport: '=',
      data: '='
    },
    link: function(scope, element, attrs, sectionController) {
      var currentQuarterStart;
      scope.today = moment();
      currentQuarterStart = moment().startOf('quarter');
      if (scope.config.type === 'metric') {
        scope.data = scope.data || {};
        scope.data.last_verified = scope.data.last_verified || moment();
        scope.data.actual = scope.data.actual || 0;
      }
      scope.metricActualIssue = function(field) {
        return !scope.grantReport.locked && !scope.grantReport.all_slots_complete && scope.data.last_verified && scope.data.last_verified.isBefore(currentQuarterStart, 'day') && !field.hasChanged && !sectionController.noChangeVerified;
      };
      return scope.metricChange = function(dybForm) {
        var field;
        field = dybForm.actual;
        return field.formData - field.viewData;
      };
    }
  };
};

module.directive('amcGrantReportItem', itemDirective);
})(angular, angular.module("amcGrantReport"));